export default function Card({ children }) {
  return <div className="bg-white rounded-half py-4 px-6">{children}</div>;
}
